export default __webpack_public_path__ + "static/media/proxima-nova-regular.6a0b31c0.woff2";